var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 이력서 제목 "), _vm.mode == 'form' ? _c('span', {
    staticClass: "page-text pink--text pl-8 font-weight-medium"
  }, [_vm._v("(필수)")]) : _vm._e()]), _c('v-sheet', [_c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.resume,
      callback: function ($$v) {
        _vm.resume = $$v;
      },
      expression: "resume"
    }
  }, 'vertical-form-table', {
    mode: _vm.mode,
    items: _vm.items
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }